import axios from "axios";
import { useCallback, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import jwt_decode from "jwt-decode";
import Actions from "../login/duck/actions";

import Operations from "../login/duck/operations";
import { API_URL } from "./constants";

export function useLoginTokenToRenew() {
  const dispatch = useDispatch();
  const userIsAuthenticated = useSelector(
    (state) => state.user.isAuthenticated
  );
  const user = useSelector((state) => state.user.profile);

  const loginUser = useCallback(
    (data, redirectPath) => {
      dispatch(
        Operations.loginUserSuccess(
          data.accessToken,
          data.refreshToken,
          data.profile,
          data?.isAccountReactivated || false
        )
      );

      if (
        redirectPath === null ||
        redirectPath === "null" ||
        redirectPath === undefined ||
        redirectPath === "undefined"
      ) {
        redirectPath = "/";
      }

      window.location.href = redirectPath;
    },
    [dispatch]
  );

  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);

    if (queryParams.get("token")) {
      if (
        userIsAuthenticated &&
        jwt_decode(queryParams.get("token")).id !== user._id
      ) {
        const shouldProceed = window.confirm(
          `You are about to be logged in as ${
            jwt_decode(queryParams.get("token")).email
          }. Continue?`
        );

        if (!shouldProceed) return;

        dispatch(Actions.logout());
      }
      const redirectPath =
        decodeURIComponent(queryParams.get("redirectTo")) || "";
      const refreshToken = queryParams.get("token");
      const payload = refreshToken.split(".")[1];

      const buffer = atob(payload).toString();
      const userObject = JSON.parse(buffer);

      if (userObject.isNew) {
        dispatch(
          Actions.setContactInfo({
            phone: userObject.phone,
            firstName: userObject.firstName,
            lastName: userObject.lastName,
            // Proof minted server-side when the WhatsApp login link was built.
            phoneVerificationToken: userObject.phoneVerificationToken,
          })
        );
        dispatch(Actions.authProvider(userObject.authProvider));
        dispatch(Actions.showOAuthRegisterModal(true));
        dispatch(Actions.redirectAfterLogin(redirectPath));
        return;
      }
      axios
        .post(`${API_URL}/v1/auth/renew/`, {
          refreshToken,
          tokenLogin: true,
        })
        .then(({ data }) => {
          loginUser(data, redirectPath);
        })
        .catch((error) => {
          console.error(error);
          toast.error("Something went wrong please try again.");
        });
    }
  }, [dispatch, loginUser]);
}
